package org.hs_soft.runmynesto.data.api_datasource.authentication

import androidx.compose.runtime.NoLiveLiterals
import org.hs_soft.runmynesto.domain.repository.network_datasource.login.ResetPasswordRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.login.SignInRepository
import org.hs_soft.runmynesto.domain.util.jsObject
import org.hs_soft.runmynesto.modules.Auth

class ResetPasswordRepositoryImpl: ResetPasswordRepository {


    @NoLiveLiterals
    override suspend fun resetPassword(
        verificationCode: String,
        newPassword: String,
        userName:String,
        onSuccess: () -> Unit,
        onError: (String) -> Unit
    ) {
        val options = jsObject<Any> {
            this["confirmationCode"] = verificationCode
            this["newPassword"] = newPassword
            this["username"] = userName
        }
        Auth.confirmResetPassword(options).then { result ->
            onSuccess()

        }.catch { error: dynamic ->
            onError(error.toString())
            console.log(error.toString())
        }

    }


}